import script from "./Bestselling.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bestselling.vue?vue&type=script&setup=true&lang=ts"

import "./Bestselling.vue?vue&type=style&index=0&id=2efd52fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efd52fa"]])

export default __exports__